import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { Trans } from '@wix/cli-i18n';
import { useVeloClient } from '@wix/velo-client';
import { useAsync, Spinner, Alert, Badge, Text } from '@wix/cli-ui-kit';
import { createDependenciesService } from '../../services/dependencies.js';
import { useProjectModel } from '../../model.js';

interface Props {
  packageName: string;
}

export const UninstallCommand: FC<Props> = ({ packageName }) => {
  const { model } = useProjectModel();
  const veloClient = useVeloClient();

  const { status } = useAsync(async () => {
    const { projectFolder } = model;
    const service = await createDependenciesService(projectFolder, veloClient);

    await service.uninstall(packageName);
  }, []);

  return match(status, {
    Loading: () => (
      <Spinner
        text={
          <Trans
            i18nKey="uninstall_command.loading"
            values={{ packageName }}
            components={[<Text bold />]}
          />
        }
      />
    ),
    Error: () => null,
    Success: () => (
      <Alert type="success">
        <Badge skin="success">
          <Trans i18nKey="general.success" />
        </Badge>{' '}
        <Trans
          i18nKey="uninstall_command.success"
          values={{ packageName }}
          components={[<Text bold />]}
        />
      </Alert>
    ),
  });
};
